module.exports = __webpack_public_path__ + "static/img/clothing_09.e4b69d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/clothing/thumbnail/clothing_09.png
// module id = SX3B
// module chunks = 0